import styled from 'styled-components'
import { Color } from '~/shared/constants/uiConstants'

export const StyledModal = {
  Wrapper: styled.div`
    display: flex;
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 10;
    background-color: rgba(0, 0, 0, 0.4);
    overflow-y: scroll;
    padding: 40px 0;
  `,
  Content: styled.div`
    width: 288px;
    margin: auto;
    padding: 24px;
    border-radius: 40px;
    background: linear-gradient(
      180deg,
      ${Color.GRAY_920} 0%,
      ${Color.GRAY_950} 100%
    );
  `,
  Text: styled.p`
    margin-bottom: 32px;
    font-weight: 700;
    font-size: 16px;
    line-height: 20px;
    text-align: center;
    color: ${Color.WHITE};
  `,
}
